/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IAlertNotificationRepository } from '@/api/fe-api/domain/repositories/alert-notification-respository';

import { GetRuleList } from '../../queries/alert-notifications/get-rule-list';

export namespace DeleteRule {
  export type Input = IAlertNotificationRepository.DeleteInput;
  export type Output = IAlertNotificationRepository.DeleteOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.alertNotification.delete(input),
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: GetRuleList.key({}),
        });
      },
    });
  }
}
